import React, { useState } from "react";

const ListItem = ({ title, subtitle, listIcon = "fas fa-ellipsis-v", handleEdit, handleDelete}) => {

  return (
    <div className="border-bottom py-2">
      <div className="row align-items-center">
        <div className="col-9 d-flex align-items-start">
          <span className="handle mr-2 mt-1">
            <i className={listIcon}></i>
          </span>
          <div className="flex-grow-1">
            <strong>{title}</strong>
            {subtitle && (
              <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                {subtitle}
              </p>
            )}
          </div>
        </div>

        <div className="col-3 text-right">
          <div className="tools">
              <button className="mr-1 btn btn-outline-primary"><i className="fas fa-edit" title="Change" onClick={handleEdit}> </i></button>
              <button className="btn btn-outline-danger"><i className="fa fa-trash-alt" title="Delete" onClick={handleDelete}></i></button>
             
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListItem;
